import { useEffect, useRef } from 'react'
import { useUserInfo } from '../use-userInfo'
import { identifyClarityUser } from '../../clarity'

const useClarityIdentify = () => {
  const { user } = useUserInfo()
  const identifiedRef = useRef<string | null>(null)

  useEffect(() => {
    if (user?.id && identifiedRef.current !== user.id) {
      identifiedRef.current = user.id
      identifyClarityUser({
        userId: user.id,
        isAdmin: user.isAdmin || false,
        teacherId: user.teacher?.id,
        entityId: user.reader?.entity?.id,
        entityName: user.reader?.entity?.name,
        entityType: user.reader?.entity?.type,
        rootId: user.reader?.root?.id,
        rootName: user.reader?.root?.name,
        entityDegree: user.reader?.entity?.degree
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id])
}

export default useClarityIdentify
